<script setup lang="ts">
import { Batch } from "@/typings/batch";

const props = defineProps<{
  batch?: Batch;
}>();
</script>

<template>
  <div class="d-flex batch-summary-stats rounded py-2 px-3">
    Total Processing:&nbsp;
    <strong>{{ batch?.processingItemCount }}</strong>
    <divider vertical class="border-dark" />
    Total Completed:&nbsp;
    <strong>{{ batch?.completedItemCount }}</strong>
    <divider vertical class="border-dark" />
    Total Failed:&nbsp;
    <strong
      ><span class="error">{{ batch?.failedItemCount }}</span></strong
    >
    <divider vertical class="border-dark" />
    Total Invoices:&nbsp;
    <strong>{{ batch?.invoicesTotal }}</strong>
    <divider vertical class="border-dark" />
    Total Payments:&nbsp;
    <strong>{{ batch?.paymentsTotal }}</strong>
  </div>
</template>

<style scoped lang="scss">
.error {
  color: var(--background-task-failed);
}
</style>
